<template>
    <div>
      <!-- 慈绸鱼详情 -->
      <div class="container">
        <div class="d-flex goods_head j-sb">
          <div class="goods_img">
            <img
              :src="course.image"
              alt=""
              style="vertical-align: middle; width: 100%"
            />
          </div>
          <div class="goods_content">
            <div class="goods_title">
              <span>{{course.name}}</span>
            </div>
            <!-- 按钮 -->
            <div class="more_button" @click="openContactUs">
              <span>
                  了解更多
              </span>
            </div>
          </div>
        </div>
        <div class="goods_detail">
          <div class="title">
              <span>详情</span>
          </div>
  
         <div class="goods_detail_bottom">
          <div class="detail_img d-flex">
              <img :src="desc.image" alt="" style="width: 100%;vertical-align: middle;" v-for="desc in course.descGroup.descList">
          </div>
         </div>
  
        </div>
      </div>
  
    </div>
  </template>
  <script>
  import CryptoJS from "crypto-js";
  const token = '1c3265b23f05b421e78e82e6ea287214'
  const encryptToken = CryptoJS.AES.encrypt(
    new Date().getTime().toString(),
    token
  ).toString();
  export default {
    data() {
      return {
        course: null
      }
    },
    created() {
      document.title = '品谱';
      this.getData()
    },
    methods:{
      openContactUs() {
        this.$router.push('/contactUs')
      },
      getData() {
        this.$axios.post("/mini/v1/course/info", {
            courseId: this.$route.query.courseId,
            encryptToken
          },{
            header: {
              "content-type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res=>{
            this.course = res.data.data.course
          })
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .d-flex {
    display: flex;
  }
  .a-center {
    align-items: center;
  }
  .j-sb {
    justify-content: space-between;
  }
  .j-center {
    justify-content: center;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    .goods_head {
      width: 100%;
      .goods_img {
        width: 500px;
        height: 500px;
      }
    }
    .goods_content {
      display: flex;
      flex-direction: column;
      width: 620px;
      .goods_title{
        margin-bottom: 20px;
        span{
          font-size: 30px;
          color: #333;
          font-weight: 600;
        }
      }
      p {
        font-weight: 500;
        font-size: 24px;
        letter-spacing: 0.04em;
        line-height: 2em;
        text-align: left;
        color: #333;
      }
      .more_button{
          width: 360px;
          height: 60px;
          margin-top: auto;
          background-color: #2e6ab0;
          text-align: center;
          cursor: pointer;
          &:hover {
              background-color: #3576c0;
            }
          span{
              color: #fff;
              font-size: 26px;
              line-height: 60px;
              letter-spacing: 1.2px;
          }
      }
    }
  
    .goods_detail{
      margin-top: 40px;
      .title{
          width: 80px;
          margin-bottom: 40px;
          font-size: 30px;
          font-weight: 600;
      }
  
      .goods_detail_bottom{
          width: 1200px;
          display: flex;
          // justify-content: center;
          .detail_img{
          width: 1200px;
          flex-direction: column;
      }
      }
  
    }
  
  }
  
  
  </style>